// extracted by mini-css-extract-plugin
module.exports = {"PageNotFound_sectionHeader":"PageNotFound_PageNotFound_sectionHeader__24b5L"};